import { useTranslation } from "react-i18next";
import {
  ApplicationPage,
  ApplicationViewHeader,
} from "../../../components/application";
import ParticipateJoinLiveSection from "../components/ParticipateJoinLiveSection";
import AssignedWorkSection from "../components/AssignedWorkSection";
import ProjectParticipationSection from "../../projects/components/ProjectParticipationSection";

export default function ParticipatePage() {
  const { t } = useTranslation();
  return (
    <ApplicationPage
      className="av-participate-page"
      variant="workspace"
    >
      <ApplicationViewHeader
        contextLabel={t(
          "facilitated_participation",
          "Facilitated participation"
        )}
        title={t("participate", "Participate")}
        description={t(
          "participate_page_intro",
          "Join a live session or access projects you participate in."
        )}
      />

      <ParticipateJoinLiveSection />

      <ProjectParticipationSection
        description={t(
          "participate_projects_description",
          "Access projects you belong to or join a new project with a code."
        )}
        title={t(
          "participate_projects_title",
          "Projects"
        )}
      />

      <AssignedWorkSection
        description={t(
          "participate_assigned_work_description",
          "Review activities assigned to your account and continue where needed."
        )}
        title={t(
          "participate_assigned_work_title",
          "Assigned work"
        )}
      />
    </ApplicationPage>
  );
}
